module.exports = __webpack_public_path__ + "static/img/kepco-cs.44d00cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kepco-cs.jpg
// module id = I0WU
// module chunks = 0